import { render, staticRenderFns } from "./WebContent.vue?vue&type=template&id=9331daa8&"
import script from "./WebContent.vue?vue&type=script&lang=js&"
export * from "./WebContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports